<template>
    <div style="padding-top: 20px;">
        <el-radio-group v-model="activeMenu" size="mini" @change="radioChange">
            <el-radio-button v-for="(value, key) in menuList" :key="key" :label="key">{{value.name}}</el-radio-button>
        </el-radio-group>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeMenu: this.$route.path,
            menuList: {
                "/weightpush": {
                    name: "手淘搜索推送",
                },
                "/push/also-like": {
                    name: "猜你喜欢推送",
                },
                "/push/mobile-small": {
                    name: "手淘微详情推送",
                },
                "/push/also-like-home": {
                    name: "手淘直播推荐",
                },
                "/push/also-like-cart": {
                    name: "购物车推荐",
                },
                "/push/my-taobao": {
                    name: "淘内免费推送",
                },
            }
        }
    },
    methods: {
        radioChange(info) {
            this.$router.push({
                path: info,
            })
        },
    }
}
</script>

<style scoped>

</style>
